import React from "react";
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import Home from "./pages/LayoutScreen/Home";
// import AuthGuard from "./services/guards/authguard";
import LayoutGuard from "./services/guards/layoutguard";
import { LoaderProvider } from "./components/loader/loader";
import Login from "./pages/CommonSreen/Login";
import ErrorInterceptor from "./services/interceptors/errorInterceptor";
import CreateContextService from "./services/CreateContextServices/CreateContextService";
import Dashboard from "./pages/Dashboard";
import MyProfile from "./pages/myprofile/MyProfile";
import CompanyProfile from "./pages/settings/Companyprofile";
import MarketingDetails from "./pages/marketing/MarketingDetails";
import AdmissionForm from "./pages/enrollment/AdmissionForm";

  function App() {
  return (
    <>
          <CreateContextService>
      <LoaderProvider>
        <Router>
        <ErrorInterceptor />
          <Routes>
            <Route path="/" element={<Login />} />
            <Route path="/Login" element={<Login />} />
            <Route path="/enrollment" element={<AdmissionForm />} />


            <Route path="" element={<LayoutGuard><Home /></LayoutGuard>}>
         
              <Route path="/dashboard" element={<LayoutGuard><Dashboard /></LayoutGuard>} />
            
              <Route path="/myprofile" element={<LayoutGuard><MyProfile /></LayoutGuard>} />
              <Route path="/companyprofile" element={<LayoutGuard><CompanyProfile /></LayoutGuard>} />
              <Route path="/marketing" element={<LayoutGuard><MarketingDetails /></LayoutGuard>} />
            

            </Route>
          </Routes>
        </Router>
      </LoaderProvider>
      </CreateContextService>
    </>
  );
}

export default App;
